import { createStore } from 'vuex';
import { getMenus, filterMenuKeys, menuKeysEqual } from '@js/config/menu-config';
import utils from '@common/utils';

const MENU_CACHE_KEY = 'SYS_USER_MENUS';

function getInitialMenuKeys() {
  const cached = utils.getLocal2Json(MENU_CACHE_KEY);
  return filterMenuKeys(Array.isArray(cached) ? cached : []);
}

const initialMenuKeys = getInitialMenuKeys();

export default createStore({
  state: {
    user: {},
    msgCount: {
      messages: 0
    },
    menus: getMenus(initialMenuKeys),
    menuKeys: initialMenuKeys,
    siderCollapsed: false,
    pageResizeCount: 0
  },
  mutations: {
    updateMenus(state, data) {
      if (menuKeysEqual(state.menuKeys, data)) {
        return;
      }
      state.menus = getMenus(data);
      state.menuKeys = data;
    },
    updateAccount(state, data) {
      state.user = data;
    },
    updateSiderCollapse(state, isShow) {
      setTimeout(() => {
        state.pageResizeCount += 1;
      }, 600);
      state.siderCollapsed = isShow;
    },
    updateMsgCount(state, data) {
      state.msgCount = data;
    }
  },
  actions: {
    updateMenuKeys({ commit }, data) {
      commit('updateMenus', data);
    },
    updateAccount({ commit }, data) {
      commit('updateAccount', data);
    },
    updateSiderCollapse({ commit }, data) {
      commit('updateSiderCollapse', data);
    },
    updateMsgCount({ commit }, data) {
      commit('updateMsgCount', data);
    }
  },
  getters: {
    account: state => {
      return state.user;
    },
    siderCollapsed: state => {
      return state.siderCollapsed;
    },
    msgCount: state => {
      return state.msgCount;
    }
  }
});
